module.exports = __webpack_public_path__ + "static/media/logo-30-anos.cfd44f1a.svg";